/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportDto } from '../../models/report-dto';

export interface ReportControllerFindOne$Params {
  id: number;
}

export function reportControllerFindOne(http: HttpClient, rootUrl: string, params: ReportControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportDto>> {
  const rb = new RequestBuilder(rootUrl, reportControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportDto>;
    })
  );
}

reportControllerFindOne.PATH = '/api/report/{id}';
